import React from 'react';
import './main.css'; // Feltételezve, hogy a CSS fájl ugyanabban a mappában lesz

const Risk: React.FC = () => {
  return (
    <section className="risk-check-section">
      <div className="risk-check-container">
        
        <div className="risk-check-text">
          <p>
            Most organisations don't know exactly where their human risk exposure sits until something goes wrong. 
            Our Organisational Risk Check offers an instant profile of where you stand and what needs improving.
          </p>
        </div>

        <div className="risk-check-action">
          {/* A gomb ami a statikus HTML fájlra mutat */}
          <a 
            href="/RISC-check/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="risk-check-btn-large"
          >
            Start your free Risk Check &rarr;
          </a>
        </div>

      </div>
    </section>
  );
};

export default Risk;